import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { PseudoLink } from '~components/Helpers/PseudoLink';

interface AddArrayItemBoxProps {
  dataTestId?: string;
  onAdd: () => void;
  title: string;
}

// The dashed "add another row" affordance that sits below a list of
// FormArrayRowCard rows.
const AddArrayItemBox = ({ dataTestId, onAdd, title }: AddArrayItemBoxProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px dashed ${theme.brandV2.colors.treadGray7}`,
        borderRadius: 2,
        cursor: 'pointer',
        mt: 2,
        py: 1.5,
        textAlign: 'center',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <PseudoLink title={title} dataTestId={dataTestId} action={() => onAdd()} />
    </Box>
  );
};

export { AddArrayItemBox };
